import React from 'react';
import {FormattedMessage} from 'react-intl';
import {IntlProvider} from 'react-intl-redux';

export default function IntlMessageComponent(props: IntlMessageComponentProps) {
  const {id, ...rest} = props;
  const lowerCaseId = id.toLowerCase();

  return (
    <IntlProvider>
      <FormattedMessage id={lowerCaseId} {...rest} />
    </IntlProvider>
  );
};